/**
 * Copyright (c) 2022 Wizart Animation.
 *
 * CONFIDENTIAL AND PROPRIETARY
 *
 * This work is provided "AS IS" and subject to the Prodtrack
 * Source Code License. By accessing, using, copying or modifying
 * this work you indicate your agreement to the Prodtrack Source Code License.
 * All rights not expressly granted therein are reserved by Wizart Animation.
 */

import React from "react";
import { Item, Button } from "semantic-ui-react";

const ErrorBoundaryFallback = ({ error, resetError }) => (
    <Item.Group
        style={{
            display: "flex",
            flexWrap: "wrap",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            alignContent: "center",
            height: "100%",
        }}
    >
        <Item
            style={{
                display: "flex",
                alignContent: "center",
                justifyContent: "center",
                flexDirection: "row",
                flexWrap: "wrap",
                width: "400px",
                alignItems: "center",
                padding: "20px",
                border: "#CACBCD solid 2px",
                borderRadius: "10px",
            }}
        >
            <Item.Content>
                <Item.Header>{"Something went wrong:"}</Item.Header>
                <Item.Description>{error.message}</Item.Description>
                <Item.Extra>
                    <Button onClick={resetError}>Try again</Button>
                </Item.Extra>
            </Item.Content>
        </Item>
    </Item.Group>
);

export default ErrorBoundaryFallback;
